import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['customerType']),
    packagePriceLabel() {
      return this.customerType === 'legal'
        ? this.$t('OFFER.PACKAGE_PRICE_EXCL_VAT')
        : this.$t('OFFER.PACKAGE_PRICE');
    },
    totalAmountLabel() {
      return this.customerType === 'legal'
        ? this.$t('OFFER.TOTAL_AMOUNT_EXCL_VAT')
        : this.$t('OFFER.TOTAL_AMOUNT');
    },
  },
};
